import { theme } from "themes/default/theme"

export const styles = {
  backdrop: {
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    inset: 0,
    // backgroundColor: "rgba(0, 0, 0, 0.6)",
    zIndex: -1,
  },
  arrow: {
    minWidth: 0,
    alignItems: "center",
    background: "#ccc",
    border: 0,
    borderRadius: "50%",
    display: "flex",
    height: "2em",
    justifyContent: "center",
    opacity: 0.7,
    padding: 0,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    width: "2em",
    zIndex: 99,
  },
  dialogContainer: {
    height: "100%",
    outline: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "none",
    position: "relative",
    flexDirection: "column",
    maxHeight: "calc(100% - 32px)",
    maxWidth: 1000,
    width: "calc(100% - 32px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    margin: "16px",
    overflow: "visible",
    "& .slick-dots": {
      "& li button": {
        "&:before": {
          color: theme.palette.primary.main,
          fontSize: 8,
        },
      },
    },
  },
  stickerBg: {
    background:
      "radial-gradient(circle, rgba(255, 255, 0, 0.5) 0%, rgba(51, 51, 51, 0.25) 70%)",
  },
  closeBtn: {
    position: "absolute",
    top: -15,
    zIndex: 1,
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "white",
    },
  },
  arrowLeft: {
    left: "1rem",
    "& svg": {
      transform: "scaleX(-1)",
    },
  },
  content: { position: "relative", background: "transparent" },
  donwloadBtn: {
    textTransform: "capitalize",
    backgroundColor: "#2a33ff",
    //  width: "50%",
    borderRadius: 4,
    minHeight: 0,
    minWidth: 0,
    lineHeight: "1",
    //   p: "10px 30px",
  },
  stickerContainer: {
    maxWidth: 900,
    m: "0 auto",
    height: "94vh", // 94vg
    justifyContent: "center",
  },
  stickerText: {
    color: "white",
  },
  dialogContent: {
    width: "100%",
  },
  donwloadBtnContainer: {
    display: "flex",
    pt: 1,
    justifyContent: "center",
  },
}
